import { useLayoutEffect, useState } from "react"

export default function useRemainingViewportHeight(anchorRef, extraOffset = 0) {
  const [viewportMetrics, setViewportMetrics] = useState({
    remainingHeight: null,
    anchorBottom: 0,
  })

  useLayoutEffect(() => {
    if (typeof window === "undefined") return undefined

    let frameId = null
    const viewport = window.visualViewport
    const resizeObserver =
      typeof ResizeObserver !== "undefined" && anchorRef?.current
        ? new ResizeObserver(() => scheduleMeasure())
        : null

    const measure = () => {
      const anchorBottom = anchorRef?.current?.getBoundingClientRect?.().bottom || 0
      const nextHeight = Math.max(Math.round(window.innerHeight - anchorBottom - extraOffset), 0)

      setViewportMetrics((currentMetrics) => {
        if (
          currentMetrics.remainingHeight === nextHeight &&
          currentMetrics.anchorBottom === anchorBottom
        ) {
          return currentMetrics
        }

        return {
          remainingHeight: nextHeight,
          anchorBottom,
        }
      })
    }

    const scheduleMeasure = () => {
      if (frameId !== null) {
        window.cancelAnimationFrame(frameId)
      }

      frameId = window.requestAnimationFrame(() => {
        frameId = null
        measure()
      })
    }

    scheduleMeasure()

    if (resizeObserver && anchorRef?.current) {
      resizeObserver.observe(anchorRef.current)
    }

    window.addEventListener("resize", scheduleMeasure)
    viewport?.addEventListener("resize", scheduleMeasure)
    viewport?.addEventListener("scroll", scheduleMeasure)

    return () => {
      if (frameId !== null) {
        window.cancelAnimationFrame(frameId)
      }

      resizeObserver?.disconnect()
      window.removeEventListener("resize", scheduleMeasure)
      viewport?.removeEventListener("resize", scheduleMeasure)
      viewport?.removeEventListener("scroll", scheduleMeasure)
    }
  }, [anchorRef, extraOffset])

  return viewportMetrics
}
